import type { Member } from '@domain/state.ts'
import { es } from '../strings/es.ts'

/** The tablet is shared, so every session starts by saying who is holding it. */
export function WhoIsIt({
  children: kids,
  onPick,
  onParents,
}: {
  children: readonly Member[]
  onPick: (id: Member['id']) => void
  onParents: () => void
}) {
  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col justify-center px-5 py-10">
      <h1 className="mb-8 text-center text-4xl font-extrabold tracking-tight">{es.who.title}</h1>
      <div className="grid gap-4 sm:grid-cols-2">
        {kids.map((child) => (
          <button
            key={child.id}
            type="button"
            className="border-rule bg-surface flex min-h-44 flex-col items-center justify-center gap-3 rounded-2xl border-4 p-6 text-2xl font-extrabold"
            style={{ borderColor: child.accent, color: child.accent }}
            onClick={() => {
              onPick(child.id)
            }}
          >
            <span aria-hidden="true" className="text-6xl">
              {child.emoji ?? '🙂'}
            </span>
            {child.name}
          </button>
        ))}
      </div>
      <button
        type="button"
        className="text-muted mx-auto mt-10 text-base font-bold underline underline-offset-4"
        onClick={onParents}
      >
        {es.who.parents}
      </button>
    </div>
  )
}
